<template>
  <a-layout-sider
    width="260"
    :trigger="null"
    collapsible
    collapsed-width="100"
    v-model="collapsed"
    class="layout-sider"
    :style="{
      boxShadow: '0px 4px 10px rgba(43, 45, 55, 0.1)',
      boxSizing: 'border-box',
      background: '#011733',
      overflow: 'visible',
    }"
  >
    <div
      :style="{
        width: collapsed ? '100px' : '260px',
      }"
      class="initMySider"
    >
      <!-- APP LOGO -->
      <div class="logo">
        <img
          src="@/assets/image/icon_logo.png"
          class="logo_icon"
          draggable="false"
          :style="{marginRight: !collapsed ? '10px':'18px'}"
          alt="icon_logo"
        />
        <img
          v-if="!collapsed"
          class="logo_title"
          src="@/assets/image/sjtj_title.png"
          draggable="false"
          alt="sjtj_title"
        />
        <div class="changeCollapsed" @click="collapsed = !collapsed">
          <a-icon
            type="menu"
            :style="{ fontSize: '24px', color: 'rgb(0,91,204)' }"
          />
        </div>
      </div>
      <!-- MENU -->
      <div class="MENU" :style="{ overflow: collapsed ? 'initial' : 'auto' }">
        <div
          v-for="v in MENU"
          :key="v.id"
          class="MENUFOR"
          :class="{ MENUFOR_SMALL: collapsed }"
        >
          <div
            class="level1"
            :class="{
              Level1Active:
                path === '/' + v.path ||
                v.children.findIndex((f) => '/' + f.path == path) > -1,
            }"
            @click="golink(v)"
          >
            <div class="icon">
              <svg-icon
                :iconClass="v.icon"
                :color="
                  path === '/' + v.path ||
                  v.children.findIndex((f) => '/' + f.path == path) > -1
                    ? '#FFF'
                    : '#666'
                "
              />
            </div>
            <div class="title" v-if="!collapsed">
              {{ v.title }}
            </div>
            <svg-icon
              v-if="!collapsed"
              icon-class="menu_right"
              class="menu_right"
              :color="
                path === '/' + v.path ||
                v.children.findIndex((f) => '/' + f.path == path) > -1
                  ? '#FFF'
                  : '#666'
              "
              :class="{ rotate_up: v.isopen }"
            />
          </div>
          <!-- 下拉展开 -->
          <!-- v-if="v.isopen && !collapsed" -->
          <div
            class="menuLevelSecondDown"
            :style="{
              width: v.isopen && !collapsed ? 'auto' : '0px',
              height: v.isopen && !collapsed ? 'auto' : '0px',
            }"
          >
            <MenuLevelSecond :children="v.children" />
          </div>
          <!-- 收缩侧边展示 -->
          <div class="menuLevelSecondRight">
            <div class="menuLevelSecondRightContent">
              <MenuLevelSecond :children="v.children" />
            </div>
          </div>
        </div>
        <!-- <div style="height: 200px; border: 1px solid red"></div> -->
      </div>
    </div>
  </a-layout-sider>
</template>

<script>
import MenuLevelSecond from "./menuLevelSecond";
export default {
  components: {
    MenuLevelSecond,
  },
  created() {
    this.MENU = JSON.parse(JSON.stringify(this.$store.state.user.menu));
    this.handleResize(); // 初始化获取屏幕宽度
    window.addEventListener("resize", this.handleResize); // 监听窗口大小变化
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize); // 组件销毁前移除事件监听
  },
  computed: {
    //当前路由
    path() {
      return this.$route.path;
    },
  },
  watch: {
    path: {
      handler(newV, oldV) {
        // console.log(newV, oldV);
        // console.log(this.MENU);
        this.MENU.forEach((v) => {
          v.children.forEach((k) => {
            "/" + k.path == newV ? (v.isopen = true) : "";
          });
        });
      },
    },
    MENU: {
      handler(newV, oldV) {
        console.log(newV, oldV);
        console.log(this.MENU);
        this.MENU.forEach((v) => {
          v.children.forEach((k) => {
            "/" + k.path == this.path ? (v.isopen = true) : "";
          });
        });
      },
    },
  },
  data() {
    return {
      MENU: [],
      collapsed: false, //true收缩false展开
      screenWidth: null,
    };
  },
  methods: {
    handleResize() {
      // this.screenWidth = window.innerWidth; // 更新屏幕宽度
      console.log(window.innerWidth);
      if (window.innerWidth < 1000) {
        this.collapsed = true;
      } else {
        this.collapsed = false;
      }
    },
    onBreakpoint(broken) {
      console.log(broken, "broken");
    },
    handleClick(e) {
      console.log("click", e);
    },
    titleClick(e) {
      console.log("titleClick", e);
    },
    golink(v) {
      if ("/" + v.path == this.path) return;
      if (v.component && v.path) {
        this.$router.replace("/" + v.path);
      } else {
        v.isopen = !v.isopen;
      }
    },
    //二级菜单中有被选中路由
    activeSecond(e) {},
  },
};
</script>

<style scoped lang="scss">
.initMySider {
  transition: all 0.2s;
}
.logo {
  width: 100%;
  height: 80px;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logo .logo_icon{
  width: 24px;
  height: 24px;
}
.logo .logo_title {
  width: 140px;
  height: 14px;
  margin-right: 22px;
  /* height: 22px; */
}
.changeCollapsed {
  width: 24px;
  height: 24px;
  // border: 1px solid red;
  cursor: pointer;
}

.MENU {
  padding: 20px;
  box-sizing: border-box;
  // border: 1px solid green;
  height: calc(100vh - 80px - 0px);
  // overflow: initial;
  overflow-y: auto;
  overflow-x: inherit;
  position: relative;
}
.MENU::-webkit-scrollbar {
  display: none;
}
.MENUFOR {
  margin-bottom: 20px;
  position: relative;
}
.MENUFOR_SMALL:hover .menuLevelSecondRight {
  display: block;
}
.layout-sider::-webkit-scrollbar {
  display: none;
}
.layout-sider {
  .ant-menu-inline {
    border-right: none;
    .ant-menu-submenu-selected {
      background: #0073ff;
      margin-bottom: 20px;
      // border-radius: 12px 12px 12px 12px;
      color: #fff;
      .ant-menu-submenu-arrow::before {
        background-image: #fff !important;
      }
    }
    .ant-menu-submenu-active {
    }
  }
}

.level1 {
  width: 100%;
  max-width: 220px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.25s;
  .title {
    width: 120px;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #9ba2ab;
    margin-left: 10px;
    margin-right: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.Level1Active {
  background: #0073ff;
  .title {
    color: #fff;
  }
}
.menu_right {
  transition: all 0.25s;
  transform: rotate(0deg);
  font-size: 20px;
}

.menuLevelSecondDown {
  transition: all 0.25s;
  padding-left: 20px;
  overflow: hidden;
}
.rotate_up {
  transform: rotate(-90deg);
}
div,
p,
span {
  user-select: none;
}

.menuLevelSecondRight {
  position: absolute;
  left: 100%;
  top: 0%;
  display: none;
  z-index: 99999;
  .menuLevelSecondRightContent {
    background: #011733;
    border-radius: 12px;
    margin-left: calc(20px + 10px);
    padding: 10px 0;
  }
}
</style>